'use client';

export function ModulesProvider({ children }) {
  return children;
}
